import { useTranslation } from '../../../hooks/useTranslation';

const useBlogBlurb = (): { showBlogBlurb: boolean } => {
  const { t } = useTranslation();
  const slug = 'BLOG_BLURB';

  return {
    // If the entry isn't found, or doesn't have
    // any content t() will return the slug. 
    showBlogBlurb: t(slug) !== slug 
  };
};

export default useBlogBlurb;
